module.exports = __webpack_public_path__ + "static/img/product-poster-4.1dbb4192.png";